module.exports = __webpack_public_path__ + "img/user-login.b0d1b553.svg";